document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.cnsp-reviews-carousel').forEach(carousel => {
    const items = carousel.querySelectorAll('.cnsp-review-item');
    if (!items.length) return;

    let index = 0;
    items[index].classList.add('active');

    const sectionId = carousel.id.replace('reviews-', '');
    const prevBtn = document.querySelector(`#cnsp-${sectionId} .cnsp-prev`);
    const nextBtn = document.querySelector(`#cnsp-${sectionId} .cnsp-next`);

    function showReview(i) {
      items.forEach(item => item.classList.remove('active'));
      items[i].classList.add('active');
    }

    prevBtn?.addEventListener('click', () => {
      index = (index - 1 + items.length) % items.length;
      showReview(index);
    });

    nextBtn?.addEventListener('click', () => {
      index = (index + 1) % items.length;
      showReview(index);
    });

    // Auto-slide every 7s
    setInterval(() => {
      index = (index + 1) % items.length;
      showReview(index);
    }, 7000);
  });
});